import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../../Hooks/useAuth';

const PublicRoute = ({ children, redirectPath }) => {
    const isUserLoggedIn = useAuth()

    return isUserLoggedIn ? <Navigate to={redirectPath || '/course'}></Navigate> : children

};

export default PublicRoute;
